import React from "react";
import styled from "styled-components";
import { config as publicRuntimeConfig } from "../../../../../../_config";

const StyleOuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1444px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 80px;
  padding-left: 80px;
  padding-right: 80px;
  

  .section-content-container {
    display: flex;
    justify-content: flex-start;
    width: 80%;
    padding: 50px;
    background: #2B6AA4;
    border-radius: 20px;
    gap: 80px;
    .divider {
      width: 1px;
      border: 1px solid #ffffff;
    }
    .section-content-column2 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .section-content-column {
      width: 100%;
      color: #ffffff;
      .section-content-column-title {
        margin-bottom: 16px;
        font-family: NoticiaText;
        font-weight: 700;
        font-size: 28px;
        line-height: 22px;
        text-align: center;
      }
      .list-header {
        font-family: NoticiaText;
        font-size: 18px;
        font-weight: 700;
        line-height: 24.57px;
        text-align: center;
        margin-top: 32px;
        margin-bottom: 16px;
      }
      ul {
        list-style: disc;
        margin-left: 18px;
        font-family: NoticiaText;
        font-size: 18px;
        font-weight: 700;
        line-height: 25px;
      }
      .section-content-column-text {
        margin-bottom: 4px;
        font-family: NoticiaText;
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        text-align: right;
        padding-right: 40px;
      }

      .section-content-column-subtext {
        margin-bottom: 4px;
        font-family: NoticiaText;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #000000;
        text-align: right;
        padding-right: 40px;
      }

      .section-content-column-message {
        padding-top: 32px;
        font-family: NoticiaText;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #07437a;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 16px;
    padding-right: 16px;
    .section-title {
      margin-bottom: 24px;
      font-size: 38px;
      line-height: 42px;
    }

    .section-content-container {
      flex-direction: column;
      gap: 32px;
      width: 100%;
      padding: 16px;
      img {
        width: 100%;
      }
      .divider {
        height: 1px;
        width: 100%;
        border: 1px solid #ffffff;
      }
      .section-content-column2 {
        width: 100%;
      }
      .section-content-column {
        width: 100%;

        &:last-child {
          padding-left: unset;
        }

        .section-content-column-title {
          margin-bottom: 16px;
          font-size: 20px;
          line-height: 20px;
        }
      }
    }
  }
`;

const StyleTopText = styled.div`
  border-width: 2px;
  border-style: solid;
  border-color: #333232;
  font-family: NoticiaText;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 18px;
  font-weight: 700;
  line-height: 19.11px;
  padding-left: 80px;
  padding-right: 80px;
  border-radius: 5px;
  margin-bottom: 30px;
  @media ${({ theme }) => theme.devices.tablet} {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 12px;
    width: 100%;
    text-align: center;
  }
` ;
const StyledButton = styled.div`
  border: 1px solid #07437A;
  box-shadow: 0px 4px 4px 0px #00000040;
  background: #ffffff;
  color: #333232;
  font-family: Aeonik;
  font-size: 18px;
  font-weight: 700;
  line-height: 28.66px;
  border-radius: 20px;
  cursor: pointer;
  text-align: center;
  padding: 8px;
  padding-left: 24px;
  padding-right: 24px;
  margin-top: 24px;
  @media ${({ theme }) => theme.devices.tablet} {
    width: 100%;
    font-size: 14px;
  }
` ;
const StartFilingSection = () => {
  return (
    <StyleOuterContainer>
      <StyledInnerContainer>
        <StyleTopText>Extension Deadline: October 15th, 2024</StyleTopText>
        <div className="section-content-container">
          <div className="section-content-column2">
          <picture>
            <source
              srcSet={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-3/start.png`}
              type="image/png"
            />
            <img src={`${publicRuntimeConfig.basePath}/images/V2/V2-landing-3/start.png`} alt="" />
          </picture>
          <a href="https://turbotax.intuit.com/personal-taxes/online/live/full-service/business-taxes/" target="_blank">
            <StyledButton>START YOUR 2023 RETURN NOW</StyledButton>
          </a>
          </div>
          <div className="divider" />
          <div className="section-content-column">
            <div className="section-content-column-title">2024 Tax Services</div>
            <div className="list-header">Don’t be late, start filing now.</div>
            <ul><li>LLCs</li>
              <li>Sole Proprietors</li>
              <li>Corporations</li>
              <li>Non Profits</li>
              <li>Church Organizations</li>
            </ul>
          </div>
        </div>
      </StyledInnerContainer>
    </StyleOuterContainer>
  );
};

export default StartFilingSection;
